// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tfa-workflow-step a{color:#fff}.tfa-workflow-step .qr-container{margin-bottom:25px;margin-top:25px}.tfa-workflow-step .qr-container button{width:100%}.tfa-workflow-step .auth-key{margin-bottom:25px}", ""]);
// Exports
module.exports = exports;
